import { defaultDateConfig } from './defaultDateConfig';
import { formatDateCustom } from './formatDateCustom';
/**
 * Formats date using default config.
 * @param {Date} date - Date to format.
 * @param {string} timeZone - Optional time zone, if not set default from `defaultDateConfig.timeZone` is used.
 * @returns {string} The formatted date string.
 */
export function formatDate(date, timeZone) {
    return formatDateCustom(date, defaultDateConfig.dateFormat, timeZone);
}
